import FetchUtils from '@dr-pam/common-components/Utils/FetchUtils';
import type { NdcAwardKind } from '@dr-pam/common-types/database/enums';
import type { NdcAwardConfigurationView } from '@dr-pam/common-components/Models/NdcCertificate';
import { NDC_AWARD_CERTIFICATES } from '@dr-pam/common-components/Models/NdcCertificate';

const API_ROOT = '/api/ndc/award-configuration';

export type NdcAwardConfigurationRequest = {
	programmeId: string;
	examQuizId: string | null;
	maintenanceProductId: string | null;
	maintenanceAgreementQuizId: string | null;
	isCertificateEnabled: boolean;
};

export function getNdcAwardConfiguration() {
	return FetchUtils.getJson<NdcAwardConfigurationView[]>(API_ROOT);
}

/** Answers with every award as saved. */
export function setNdcAwardConfiguration(kind: NdcAwardKind, request: NdcAwardConfigurationRequest) {
	return FetchUtils.putJson<NdcAwardConfigurationView[], NdcAwardConfigurationRequest>(
		`${API_ROOT}/${NDC_AWARD_CERTIFICATES[kind]}`,
		request,
	);
}
